import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import { COLORS } from 'src/data/ui';

export const IconLightBulb = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
      data-fill-none
    >
      <path
        d="M10 11.5V13C10 13.2652 9.89464 13.5196 9.70711 13.7071C9.51957 13.8946 9.26522 14 9 14H7C6.73478 14 6.48043 13.8946 6.29289 13.7071C6.10536 13.5196 6 13.2652 6 13V11.5"
        stroke={COLORS.gray.gray50}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 0.5V1.5"
        stroke={COLORS.gray.gray50}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 7.5H2"
        stroke={COLORS.gray.gray50}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 2.5L3.23333 3.20467"
        stroke={COLORS.gray.gray50}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 7.5H14"
        stroke={COLORS.gray.gray50}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4999 2.5L12.7666 3.20467"
        stroke={COLORS.gray.gray50}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.9432 11.5H10.0565C10.7994 11.1313 11.4229 10.5601 11.8552 9.85243C12.2875 9.14471 12.511 8.32923 12.4999 7.5C12.4788 6.31311 11.9979 5.18071 11.1586 4.34132C10.3192 3.50192 9.18676 3.02106 7.99987 3C6.81252 3.02108 5.67974 3.50231 4.84027 4.34227C4.00081 5.18224 3.52024 6.31531 3.49987 7.50267C3.48929 8.33145 3.71302 9.14636 4.14529 9.85356C4.57756 10.5608 5.20079 11.1315 5.9432 11.5Z"
        stroke={COLORS.gray.gray50}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9V11.5"
        stroke={COLORS.gray.gray50}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 7.5L8 9L9.5 7.5"
        stroke={COLORS.gray.gray50}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
